import { useRef, useEffect } from "react";
import { useFrame} from "@react-three/fiber";
import * as THREE from "three";

export default function CameraController() {
  const cameraRef = useRef();
  const isMobile = useRef(/Mobi|Android/i.test(navigator.userAgent)).current;
  const mouse = useRef({ x: 0, y: 0 });
  const rotation = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const clampRotation = (angle) => THREE.MathUtils.clamp(angle, THREE.MathUtils.degToRad(-25), THREE.MathUtils.degToRad(25));

    if (!isMobile) {
      window.addEventListener('mousemove', (e) => {
        mouse.current.x = (e.clientX / window.innerWidth - 0.5) * -0.1;
        mouse.current.y = (e.clientY / window.innerHeight - 0.5) * -0.1;
      });
    } else {
      const handleTouchMove = (e) => {
        if (e.touches.length === 1) {
          const touch = e.touches[0];
          const movementX = touch.clientX - (mouse.current._lastX || touch.clientX);
          const movementY = touch.clientY - (mouse.current._lastY || touch.clientY);

          rotation.current.x += movementX * 0.002;
          rotation.current.y -= movementY * 0.002; // invert Y direction

          rotation.current.x = clampRotation(rotation.current.x);
          rotation.current.y = clampRotation(rotation.current.y);

          mouse.current._lastX = touch.clientX;
          mouse.current._lastY = touch.clientY;
        }
      };

      const handleTouchEnd = () => {
        mouse.current._lastX = null;
        mouse.current._lastY = null;
      };

      window.addEventListener('touchmove', handleTouchMove);
      window.addEventListener('touchend', handleTouchEnd);
    }
  }, [isMobile]);

  useFrame(({ camera }) => {
    if (!cameraRef.current) {
      cameraRef.current = camera;
    }

    camera.rotation.x = isMobile ? rotation.current.y : THREE.MathUtils.clamp(mouse.current.y, THREE.MathUtils.degToRad(-25), THREE.MathUtils.degToRad(25));
    camera.rotation.y = isMobile ? rotation.current.x : THREE.MathUtils.clamp(mouse.current.x, THREE.MathUtils.degToRad(-25), THREE.MathUtils.degToRad(25));

    camera.position.z = isMobile ? 1.4 : 1.2;
    camera.fov = isMobile ? 75 : 45;
  });

  return null;
}